import React from 'react';
import clsx from 'clsx';
import useCategoriesByPlailist from 'sdk/hooks/useCategoriesByPlailist';
import styles from './CategoriesFilter.module.scss';
import { useTranslation } from 'react-i18next';

function CategoriesFilter({
  value, onChange, nameAsId = false, disabledNfts, playlistId,
}: {
  value: string | null,
  onChange: (v: string | null) => void,
  nameAsId?: boolean,
  disabledNfts?: boolean
  playlistId?: number
}) {
  const {t} = useTranslation() as any
  const categoriesData = useCategoriesByPlailist(playlistId)
  const categories = disabledNfts
    ? categoriesData?.data?.filter((c: any) => c.isNFT !== false) : categoriesData?.data || []

  return (
    <div className={styles.container}>
      <div
        className={clsx(
          styles.item,
          !value && styles.itemActive,
        )}
        onClick={() => onChange(null)}
      >
        {t('All')}
      </div>
      {(categories || []).map((cat) => (
        <div
          key={cat?.id}
          className={clsx(
            styles.item,
            (value === (nameAsId ? cat?.name : cat?.id)) && styles.itemActive,
          )}
          onClick={() => onChange(nameAsId ? cat?.name : cat?.id)}
        >
          {t(cat?.name)}
        </div>
      ))}
    </div>
  )
}

export default CategoriesFilter
